/* eslint-disable import/prefer-default-export */
export const BOOK_LIST = `
  query($projectId: Int) {
    bookList(projectId: $projectId) {
      project {
        id
        code
        name
      }
      book {
        id
        name
        subjectId
        labelId
        type
        projectCode
      }
    }
  }
`;

export const LEVEL_LIST = `
  query($bookId: Int, $type: String) {
    levelList(bookId: $bookId, type: $type) {
      passList {
        itemType
        itemCode
        unitId
        wordbankIds
        star
        isUnlock
      }
      toggleButton
    }
  }
`;

export const LEVEL_USER_INFO = `
  query {
    levelUserInfo {
      userId
      userName
      userPhone
      userAvatar
      level
      exp
      title
      integral
      afterTime
      energy
    }
  }
`;

export const LEVEL_ENERGE = `
  query {
    levelEnergy {
      afterTime
      energy
    }
  }
`;

export const USE_ENERGY_DATA = `
  mutation{
    usedEnergyData
  }
`;
